export default __webpack_public_path__ + "static/media/monsterMyCity1.0d600906.png";